'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { NextCacheProvider as CacheProvider } from '@effektify/cache';
import { IntercomProvider } from 'react-use-intercom';
import { Provider as ThemeProvider } from 'src/Theme';
import I18nProvider from 'src/contexts/translations/i18nProvider';
import 'src/utils/dayjs';
interface RootProps {
  children: React.ReactNode;
  className?: string;
}
const INTERCOM_APP_ID = process.env.NEXT_PUBLIC_INTERCOM_APP_ID || '';
const Root: React.FC<RootProps> = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      zIndex: 100
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <IntercomProvider appId={INTERCOM_APP_ID} autoBoot={true} autoBootProps={t1}><CacheProvider><ThemeProvider><I18nProvider>{children}</I18nProvider></ThemeProvider></CacheProvider></IntercomProvider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default Root;
export type { RootProps };